'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M16 400c0 53 43 96 96 96l256 0c53 0 96-43 96-96s-43-96-96-96l-256 0c-53 0-96 43-96 96zM48 208l0 16 0 84.1C66.1 295.4 88.2 288 112 288l256 0c23.8 0 45.9 7.4 64 20.1l0-4.1 0-56c0-22.1-17.9-40-40-40l-40 0-71.8 0L48 208zm64 192a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm96 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm96 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm96 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M48 72c0-13.3 10.7-24 24-24l101.1 0c8.8 0 16.8 4.8 21 12.4L266.5 192 48 192 48 72zm0 136l231.9 0 .3 0 71.8 0 40 0c22.1 0 40 17.9 40 40l0 56 0 4.1c-18.1-12.7-40.2-20.1-64-20.1l-256 0c-23.8 0-45.9 7.4-64 20.1L48 224l0-16zm400 96l0-56c0-30.9-25.1-56-56-56l-32 0 0-64c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 64-59.3 0L208.1 52.7c-7-12.8-20.5-20.7-35-20.7L72 32C49.9 32 32 49.9 32 72l0 120 0 8 0 24 0 96 1.6 0C12.9 340.3 0 368.7 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-31.3-12.9-59.7-33.6-80l1.6 0 88 0 0 56.6c0 17 6 33.5 17 46.5l72.9 86.1c2.9 3.4 7.9 3.8 11.3 .9s3.8-7.9 .9-11.3l-72.9-86.1c-8.6-10.1-13.3-22.9-13.3-36.2l0-113.1c0-13.2 4.7-26.1 13.3-36.2l72.9-86.1c2.9-3.4 2.4-8.4-.9-11.3s-8.4-2.4-11.3 .9L553 216.9c-11 13-17 29.5-17 46.5l0 40.6-88 0zm-336 0l256 0c53 0 96 43 96 96s-43 96-96 96l-256 0c-53 0-96-43-96-96s43-96 96-96zM96 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm304-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;